<!--
    <div class="toggle-container" id="toggleContainer">
        <div class="toggle-option" data-option="1">选项一</div>
        <div class="toggle-option" data-option="2">选项二</div>
        <div class="toggle-bg"></div>
    </div>

    const toggleContainer = document.getElementById('toggleContainer');
    const toggleOptions = document.querySelectorAll('.toggle-option');

    // 切换选项
    toggleOptions.forEach(option => {
        option.addEventListener('click', () => {
            const optionValue = option.getAttribute('data-option');
            toggleContainer.className = 'toggle-container';
            if (optionValue === '2') {
                toggleContainer.classList.add('option2');
            }
        });
    });

-->
<!-- 滑动胶囊Tab -->
<template>
    <div class="toggle-container" :class="{ 'option2': selIndex == 2 }">
        <div v-for="item,index in list" :class="{active: selIndex==(index+1)}" :key="index" class="toggle-option" @click="tabOption(item.index)">
            {{ item.label }}
        </div>
        <div class="toggle-bg"></div>
    </div>
</template>

<script>

export default {
    name: 'SlideCapsuleTab',
    props: ['tabIndex', 'areaId'],
    data() {
        return {
            selIndex: 1,
            list: [{
                index: 1,
                label: '选号推荐'
            },
            {
                index: 2,
                label: '杀号推荐'
            }]
        }
    },
    watch: {
        tabIndex: {
            handler(newVal) {
                this.selIndex = newVal
            },
            immediate: true // 组件创建时立即执行
        }
    },
    methods: {
        // 点击切换选项卡
        tabOption(v) {
            this.selIndex = v;
            this.$bus.$emit('slideTab', v);
        }
    }
}
</script>

<style scoped>
.toggle-container {
    display: flex;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 50px;
    padding: 4px;
    position: relative;
    width: 140px;
    margin-left: auto;
    font-size: 13px;
    align-items: center;
    height: 20px;
    border: 1px solid #b2b2b2;
}

.toggle-option {
    flex: 1;
    text-align: center;
    padding: 2px;
    color: #202020;
    cursor: pointer;
    position: relative;
    z-index: 2;
    transition: color 0.3s ease;
}

.toggle-bg {
    position: absolute;
    top: 3px;
    left: 3px;
    height: calc(100% - 6px);
    width: calc(50% - 3px);
    background: linear-gradient(90deg, #ff8a00, #e52e71);
    border-radius: 50px;
    transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

/* 当第二个选项被选中时，背景滑动到右侧 */
.toggle-container.option2 .toggle-bg {
    left: calc(50% + 0px);
    background: linear-gradient(90deg, #00b4db, #0083b0);
}

/* 悬停效果 */
.toggle-option:hover {
    color: rgba(255, 255, 255, 0.9);
}

.active{
    color: white;
    font-weight: 600;
}
</style>